export const MINUTE_PILL_COLOR_CLASSES = {
  highlight: "bg-yellow text-black", // highlighted events (e.g. goals)
  neutral: "bg-gray-600 text-white",
  transparent: "bg-transparent text-white",
} as const;
